import { WMCheckbox } from '@walkme/wm-ui';
import React, { useContext } from 'react';
import { AppTableContext } from '../AppTableContext';
import { IAppTableRowData } from '../model';

interface ISelectAllButtonProps {
    data: IAppTableRowData[];
    isAllSelected: boolean;
    isSomeSelected: boolean;
    disabled: boolean;
}

export const SelectAllButton = ({ data, isAllSelected, isSomeSelected, disabled }: ISelectAllButtonProps) => {
    const { tableDataTestid, onTableDataChange } = useContext(AppTableContext);

    return (
        <WMCheckbox
            ds2
            disabled={disabled}
            checked={!disabled && (!!isSomeSelected || !!isAllSelected)}
            indeterminate={!disabled && isSomeSelected && !isAllSelected}
            inputProps={{ 'data-testid': `${tableDataTestid}-select-all-button` } as $TSFixMe}
            onChange={e => {
                if (onTableDataChange) {
                    if (e.target.checked) {
                        onTableDataChange({ selectedIds: data.map(n => n.id) });
                    } else {
                        onTableDataChange({ selectedIds: [] });
                    }
                }
            }}
        />
    );
};
